import React, { useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import Toast from "../../components/Toast/Toast";
import Sidebar from "../Sidebar/Sidebar";
import OrderReport from "./components/OrderReport";
import WholesellerReport from "./components/WholesellerReport";
import RetailerReport from "./components/RetailerReport";
import "./Report.css";

const Report = () => {
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const [expandedSections, setExpandedSections] = useState({
    order: true,      // Order expanded by default
    wholeseller: false,
    retailer: false
  });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: "", type: "" }), 3000);
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <>
      <Toast toast={toast} />
      <div className="Report-layout">
        <Sidebar />
        <div className="Report-main-content">

          {/* Order Report Section */}
          <div className="report-section">
            <div 
              className="report-section-header"
              onClick={() => toggleSection('order')}
            >
              <div className="section-title">
                <h2>Order Report</h2>
              </div>
              <div className="section-toggle">
                {expandedSections.order ? <FaChevronDown /> : <FaChevronRight />}
              </div>
            </div>
            {expandedSections.order && (
              <div className="report-section-content">
                <OrderReport showToast={showToast} />
              </div>
            )}
          </div>

          {/* Wholeseller Report Section */}
          <div className="report-section">
            <div 
              className="report-section-header"
              onClick={() => toggleSection('wholeseller')}
            >
              <div className="section-title">
                <h2>Wholeseller Report</h2>
              </div>
              <div className="section-toggle">
                {expandedSections.wholeseller ? <FaChevronDown /> : <FaChevronRight />}
              </div>
            </div>
            {expandedSections.wholeseller && (
              <div className="report-section-content">
                <WholesellerReport showToast={showToast} />
              </div>
            )}
          </div>

          {/* Retailer Report Section */}
          <div className="report-section">
            <div 
              className="report-section-header"
              onClick={() => toggleSection('retailer')}
            >
              <div className="section-title">
                <h2>Retailer Report</h2>
              </div>
              <div className="section-toggle">
                {expandedSections.retailer ? <FaChevronDown /> : <FaChevronRight />}
              </div>
            </div>
            {expandedSections.retailer && (
              <div className="report-section-content">
                <RetailerReport showToast={showToast} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Report; 